import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import ModalInvitados from './ModalInvitados';
import React, {Component} from 'react';
import firebase from 'firebase';
import Modal from 'react-modal';
import Alert from 'react-s-alert';
import store from '../../store';


const qrCode = require('qrcode-npm');


const database= firebase.database();



const text="-L6TFyzo5H6lBpdIisHA";
const qr = qrCode.qrcode(4, 'M');



const customStyles = {
  content : {
    top                   : '75%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    transform             : 'translate(-50%,-50%)',
	width                 : '450px'
	
  }
};

class Invitados extends Component{

	constructor(props){

		super(props);
		this.state={
			invitados:[],
			isActive:false,
			invitadoKey:'',
			nombre:'',
			apellido:'',
			dui:'',
			pasaporte:'',
			correo:'',
			contrasena:'',
			fecha_inicio:'',
			fecha_final:'',
			hora_inicio:'',
			hora_final:'',
			template:false
	
		}
		this.invitadosRef=database.ref().child('Invitados');
		this.toggleModal=this.toggleModal.bind(this);
		this.handleClick=this.handleClick.bind(this);
		this.handleSubmit=this.handleSubmit.bind(this);
		this.handleKeyPressDui=this.handleKeyPressDui.bind(this);
		this.ocultarMenu=this.ocultarMenu.bind(this);
		this.handleClickAlerta=this.handleClickAlerta.bind(this);
		this.handleClickClose=this.handleClickClose.bind(this);
		
		
		
		this.AlertaContenido = ({
		  id,
		  classNames,
		  styles,
		  message,
		  customFields,
		  handleClose,
		}) => {
		const handleConfirm = () => {
			
			this.handleSubmit();
			Alert.close(id);
			this.setState({
				template:false
			})
		}
			return (
			<div className={classNames} id={id} style={styles}>
			  <div className='s-alert-box-inner'>
					{message}
			  </div>
			  <br/>
			  <br/>
			  <button className="customButton btn btn-success btn-alerts btn-m" onClick={handleConfirm.bind(this)}>Confirmar</button>
			  <button className="customButton btn btn-default btn-alerts btn-m-r" onClick={this.handleClickClose}>Cancelar</button>
			  <span className='s-alert-close' onClick={handleClose}></span>
			</div>
			);
		}
		
		qr.addData(text);
		qr.make();
		
		
	}

	componentDidMount(){

		this.invitadosRef.on('value',this.gotData,this.errData);

	}

	componentWillMount(){


	}

	
	
	handleClickAlerta(event){
		this.setState({
			template:true
			
		})
		const customerName = 'Acacya';
		Alert.success('¿Deseas confirmar los cambios?', {
		  position: 'top-right',
		  timeout:'none',		  
		  customFields: {
			customerName: customerName
		  }
		});
		
		event.preventDefault();
	}
  
  
	handleClickClose(){		
		Alert.closeAll();
	}
	
	
	
	
	
	handleSubmit(){
		
		let nombre=this.nombre.value;
		let apellido=this.apellido.value;
		let dui=this.dui.value;
		let pasaporte=this.pasaporte.value;
		let correo=this.correo.value;
		let contrasena=this.password.value;
		let fecha_inicio=this.fecha_inicio.value;
		let fecha_final=this.fecha_final.value;
		let hora_inicio=this.hora_inicio.value;
		let hora_final=this.hora_final.value;
		
		this.invitadosRef.child(this.state.invitadoKey).update({
			
			nombre:nombre,
			apellido:apellido,
			dui:dui,
			pasaporte:pasaporte,
			fecha_inicio:fecha_inicio,
			fecha_final:fecha_final,
			hora_inicio:hora_inicio,
			hora_final:hora_final
			
		});
		
		Alert.success('Datos actualizados correctamente', {
				effect: 'genie',
				position: 'bottom-right',
				timeout:2000			
		});
		
		
		
		
	
	
		this.toggleModal();
	

	}
		
	
	toggleModal(){
		
		this.setState({
			
			isActive:!this.state.isActive
			
		})
	}
	
	handleClick(row){
	
	
		
		this.setState({
			
			invitadoKey:row.key,
			nombre:row.nombre,
			apellido:row.apellido,
			dui:row.dui,
			pasaporte:row.pasaporte,
			correo:row.correo,
			contrasena:row.contrasena,
			fecha_inicio:row.fecha_inicio,
			fecha_final:row.fecha_final,
			hora_inicio:row.hora_inicio,
			hora_final:row.hora_final
	
	
		})
		
		
		this.toggleModal();
		
	}
	
	gotData=(data)=>{
	
		let newInvitados=[];
		let datainvitados=data.val();

		if(datainvitados!==null){

			let keys=Object.keys(datainvitados);

			for(let i=0;i<keys.length;i++){

				let k=keys[i];

	
				
				newInvitados.push({
					key:k,
					nombre:datainvitados[k].nombre,
					apellido:datainvitados[k].apellido,
					dui:datainvitados[k].dui,					
					pasaporte:datainvitados[k].pasaporte,
					correo:datainvitados[k].correo,
					contrasena:datainvitados[k].contrasena,
					fecha_inicio:datainvitados[k].fecha_inicio,
					fecha_final:datainvitados[k].fecha_final,
					hora_inicio:datainvitados[k].hora_inicio,
					hora_final:datainvitados[k].hora_final

				})
				
			}
			this.setState({invitados:newInvitados});
		}


	}
	errData=(err)=>{

		console.log(err);
	}


	imgFormatter(cell,row) {
		 
		return  <button className="btn btn-success btn-sm" onClick={() => {this.handleClick(row)}} >Editar</button>;
	}
	
	
	handleKeyPressDui(e){
		
		
		let dui=this.dui.value;
		let tecla=e.which;
		
		if(dui.length===8)
		{
			if(!(tecla===45)){
				
				e.preventDefault();
			}
			
		}else{
			
			
			let patron =/^[0-9]+$/;
			
			let tecla_final = String.fromCharCode(tecla);
			
			let rs=patron.test(tecla_final);
		
			if(!rs){
				
				e.preventDefault();
			}
		}
			
	}

	
	
	ocultarMenu(){
		

		store.dispatch({
			
			type: 'STATE_MOSTRAR',
			mostrar:'noMostrar'
		})
	}
	
	render(){
			return(
					<div className="Invitados container" onClick={this.ocultarMenu}>	
							<h1 className="titulo">Invitados</h1>
							
							
							{this.state.template ? <Alert  timeout='none' contentTemplate={this.AlertaContenido} />:<Alert stack={{limit: 3}} html={true} />}
							<ModalInvitados/>
						<BootstrapTable data={ this.state.invitados}
							 ref='table'
							 pagination={ true }
							 search={ true }
							 hover
							 >
							 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
							 <TableHeaderColumn dataField='nombre' dataSort={true}  >Nombre</TableHeaderColumn>						
							 <TableHeaderColumn dataField='apellido' dataSort={true}  >Apellido</TableHeaderColumn>						
							 <TableHeaderColumn dataField='correo' dataSort={true}  >Correo</TableHeaderColumn>						
							 <TableHeaderColumn dataField='pasaporte' dataSort={true}  >Pasaporte</TableHeaderColumn>						
							 <TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={ this.imgFormatter.bind(this) }>Editar</TableHeaderColumn>
						</BootstrapTable>
						
					
					<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModal}  style={customStyles} >				
					
							<h3>Agregar invitados</h3>
							
							<hr/>
					
							<form method="POST" action="" onSubmit={this.handleClickAlerta}>
								<div className="form-group">
									<label htmlFor="nombre" >Nombre</label>
									<input type="text" name="nombre"  placeholder="Nombre" className="form-control"
									required autoComplete="off" 
									ref={input=>{this.nombre=input}}
									defaultValue={this.state.nombre}
									/>
								</div>
								<div className="form-group">
									<label htmlFor="apellido">Apellido</label>
									<input type="text" name="apellido" className="form-control" placeholder="Apellido"
									required autoComplete="off" 
									ref={input=>{this.apellido=input}}
									defaultValue={this.state.apellido}
									/>
								</div>
								<div className="form-group">
								    <label htmlFor="dui">Dui</label>
									<input type="text" name="dui" className="form-control" placeholder="Dui"
									maxLength="10" minLength="10"
									required autoComplete="off" 
									ref={input=>{this.dui=input}}
									defaultValue={this.state.dui}
									onKeyPress={this.handleKeyPressDui}
									
									/>								
								</div>
								<div className="form-group">
									<label htmlFor="correo">Correo</label>
									<input type="email" name="correo" className="form-control" placeholder="Correo"
									required autoComplete="off" 
									ref={input=>{this.correo=input}}
									defaultValue={this.state.correo}
									disabled="disabled"
									/>
								</div>
										
								<div className="form-group">
									<label htmlFor="Contraseña">Contraseña</label>
									<input type="text" name="contrasena" className="form-control" placeholder="Contraseña" 
									required autoComplete="off" 
									ref={input=>{this.password=input}}
									defaultValue={this.state.contrasena}
									disabled="disabled"
									/>
								</div>
								
								<div className="form-group">
										<label>Fecha inicio</label>
										<input type="date" name="fecha_inicio"  required autoComplete="off"
										defaultValue={this.state.fecha_inicio} className="form-control"
										ref={input=>{this.fecha_inicio=input}}
										/>
								</div>
								<div className="form-group">
										<label>Fecha fin</label>
										<input type="date" name="fecha_final"  required autoComplete="off"
										defaultValue={this.state.fecha_final} className="form-control"
										ref={input=>{this.fecha_final=input}}
										/>
								</div>
								<div className="form-group">
										<label>Hora inicio</label>
										<input type="time" name="fecha"  required autoComplete="off"
										defaultValue={this.state.hora_inicio} className="form-control"
										ref={input=>{this.hora_inicio=input}}
										/>
								</div>
								<div className="form-group">
										<label>Hora fin</label>
										<input type="time" name="fecha"  required autoComplete="off"
										defaultValue={this.state.hora_final} className="form-control"
										ref={input=>{this.hora_final=input}}
										/>
								</div>
						
								<div className="form-group">
									<label htmlFor="pasaporte">Pasaporte</label>
									<input type="text"  name="pasaporte" className="form-control" placeholder="Pasaporte"
									required autoComplete="off" 
										ref={input=>{this.pasaporte=input}}
										defaultValue={this.state.pasaporte}
									/>
								</div>
								
							<button type="submit" className="btn btn-primary buttons" >Guardar</button>
						</form>
							<button type="button" className="btn btn-default buttons  btnmargin" onClick={this.toggleModal}>Cerrar</button>
					
					</Modal>
						
					</div>
			);
	}
}

export default Invitados;


// WEBPACK FOOTER //
// ./src/Components/Invitados/Invitados.js